<template>
  <v-container
    id="detalhe-clientes-faturado-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-container>
              <dashboard-filtro-datas
                :primeiro="enablePrimeiroDia"
                :ultimo="enableUltimoDia"
                :empresas="enableEmpresa"
                :vendedores="enableVendedor"
                :supervisores="enableSupervisor"
                :areas="enableArea"
                :redes="enableRede"
                :receitas="enableReceita"
                :segmentos="enableSegmento"
                :cliente="enableClientes"
              />
            </v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-card
                        id="cardDashbord"
                        class="mx-auto"
                        outlined
                      >
                        <div class="card-header-dashbord">
                          <v-row>
                            <v-col
                              cols="12"
                              sm="10"
                              md="10"
                              lg="10"
                              class="d-flex flex-wrap"
                            >
                              Relatório de Clientes Faturados
                            </v-col>
                            <v-col
                              cols="12"
                              sm="2"
                              md="2"
                              lg="2"
                              class="d-flex justify-end"
                            >
                              <v-tooltip top>
                                <template
                                  v-slot:activator="{ on, attrs }"
                                >
                                  <v-icon
                                    id="iconInformationClientesFaturados"
                                    class="text-left"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span>Este relatório lista todos os clientes que faturaram na data filtrada.</span><br>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </div>
                        <v-card-actions>
                          <v-row v-if="loading">
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                :style="styleObject"
                                class="text-center"
                              >
                                <v-icon
                                  light
                                  class="custom-loader"
                                  :style="styleObject"
                                >
                                  mdi-cached
                                </v-icon>
                                Carregando dados...
                              </div>
                            </v-col>
                          </v-row>
                          <v-row v-else-if="error">
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                class="alert alert-danger"
                              >
                                {{ error }}
                              </div>
                            </v-col>
                          </v-row>
                          <v-row v-else>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                id="idTable"
                                style="overflow-x: auto; max-width: 100%;"
                              >
                                <table
                                  style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                                  class="elevation-1"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Cliente
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Cidade
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Estado
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        País
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Segmento Cliente
                                      </th>
                                      <th
                                        id="dadoMovimentacaoHeader"
                                        style="text-align: center;"
                                        class="black--text title"
                                      >
                                        Faturamento
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="item in dadosDetalhamento"
                                      :key="item.id"
                                    >
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left;"
                                      >
                                        {{ item.cliente }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left;"
                                      >
                                        {{ item.cidade }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left;"
                                      >
                                        {{ item.estado }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left;"
                                      >
                                        {{ item.pais }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left;"
                                      >
                                        {{ item.segmento_cliente }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right;"
                                      >
                                        {{ item.faturamento }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Cliente from '../../../../../services/somentecliente'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardClienteFaturadosDetalhamento',
    emits: ['atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedor: true,
      enableSupervisor: true,
      enableArea: true,
      enableRede: true,
      enableReceita: true,
      enableSegmento: true,
      enableClientes: true,
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receitaIds: [],
      segmento: [],
      selectCategoria: [],
      selectPromotor: [],
      clientes: [],
      menu: false,
      menu1: false,
      loading: false,
      error: null,
      headersDetalhamento: [
        { text: 'Cliente', value: 'cliente', width: '300px', class: 'black--text title' },
        { text: 'Cidade', value: 'cidade', width: '200px', class: 'black--text title' },
        { text: 'Estado', value: 'estado', width: '100px', class: 'black--text title' },
        { text: 'País', value: 'pais', width: '100px', class: 'black--text title' },
        { text: 'Segmento Cliente', value: 'segmento_cliente', width: '200px', class: 'black--text title' },
        { text: 'Faturamento', value: 'faturamento', width: '150px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        eventEmit.$emit('atualizar_texto', 'Cliente')
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, classificacao, produto, cidade, categoria, promotor, linhasProducao, primeiroDiaStatus, dataStatus, motorista, statusEntrega, ordem, opcaoOrdenacao, orientacaoOrdem, clientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.clientes = clientes

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaId', JSON.stringify(this.select || []))

        this.updateDate()
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.showDelhamentoClientesFaturados()
      },

      async showDelhamentoClientesFaturados () {
        this.loading = true

        await Cliente.showDetalheClienteFaturados(this.primeiroDia, this.ultimoDia, this.select, this.vendedorSelect, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.segmento, this.receita, this.selectCategoria, this.selectPromotor, this.clientes).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.clientesFaturado.map((item) => {
              this.valorVencido = item.valor_vencido

              var listaDetalhamento = ({
                cliente: item.nome_cliente,
                cidade: item.cidade,
                estado: item.estado,
                pais: item.pais,
                segmento_cliente: item.segmento_cliente,
                faturamento: parseFloat(item.faturamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>
<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

  #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #textoTabela {
    font-size: 0.75rem !important
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  // #bloco1
    // margin-left: -5rem

  #relatorioClientesFaturados
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationClientesFaturados
    margin-left: 9.5rem
    font-weight: bold

  #headersClientesFaturados
    margin-left: 1.7rem
    margin-right: 1.7rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
